// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  enabled: true, // Sentry disabled until we have a new one setup
  dsn: SENTRY_DSN || 'https://54b2d96aa8e61ba1076725b0b754b85e@o663088.ingest.us.sentry.io/4508937344385024',
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  // tracesSampleRate: 0.2,
  tracesSampleRate: 0.1,

});
